/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum OrderStatus {
  REQUESTED = 'requested',
  PAID = 'paid',
  CONFIRMED = 'confirmed',
  PAID_WITH_VOUCHER = 'paid_with_voucher',
  CONVERTED_TO_VOUCHER = 'converted_to_voucher',
  CONVERTED_FROM_VOUCHER = 'converted_from_voucher',
  PAYMENT_LINK_GENERATED = 'payment_link_generated',
  CONVERTED_FROM_WAITLIST = 'converted_from_waitlist',
  PAID_WITH_PAYMENT_LINK = 'paid_with_payment_link',
  PAID_WITH_PASS = 'paid_with_pass',
  PAID_WITH_EXTERNAL_VOUCHER = 'paid_with_external_voucher',
  DEPOSIT_PAID = 'deposit_paid',
  ABANDONED = 'abandoned',
  ARCHIVED = 'archived',
  PENDING_CONFIRMATION = 'pending_confirmation',
}
